import React from "react";

type StatusPillProps = {
  label: string;
  active?: boolean;
  onClick?: () => void;
};

const StatusPill = ({ label, active = false, onClick }: StatusPillProps) => {
  return (
    <button
      className={`status-pill ${active ? "active" : ""}`}
      type="button"
      onClick={onClick}
      disabled={!onClick}
    >
      {label}
    </button>
  );
};

export default StatusPill;
